"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var adaptive_1 = __importDefault(require("./adaptive"));
var Small = function (_a) {
    var fill = _a.fill, title = _a.title, background = _a.background, rest = __rest(_a, ["fill", "title", "background"]);
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 270 270", version: "1.1" }, rest),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("circle", { cx: "135", cy: "135", r: "135", fill: fill }),
        react_1.default.createElement("path", { d: "M 240.48,159.54 H 252.36 V 139.98 H 240.48 V 127.02 H 214.08 V 139.98 H 185.04 V 139.74 C 209.04,130.38 221.4,114.3 221.4,96.54 V 92.34 H 193.8 V 96.18 C 193.8,114.66 187.08,130.98 171.24,139.98 V 159.54 H 213.6 V 179.22 H 240.48 Z M 17.64,179.22 H 87.96 V 159.54 H 44.52 V 145.5 H 78.6 V 125.82 H 44.52 V 112.02 H 87.24 V 92.34 H 17.64 Z M 140.39,118.62 C 140.39,130.26 123.11,143.94 93.95,159.54 V 179.22 H 166.67 V 159.54 H 114.59 V 159.3 C 148.43,150.42 167.75,136.5 167.75,118.86 V 115.62 C 167.75,99.42 154.67,90.78 132.71,90.78 H 130.43 C 106.19,90.78 94.43,100.74 94.43,121.5 V 128.58 H 121.07 V 121.5 C 121.07,113.46 124.67,109.5 131.51,109.5 137.39,109.5 140.39,112.74 140.39,118.38 Z", fill: "#fffbf8" })));
};
var E24 = function (props) {
    var _a = props.fill, fill = _a === void 0 ? '#1c1d1f' : _a, rest = __rest(props, ["fill"]);
    return react_1.default.createElement(adaptive_1.default, __assign({ small: Small, fill: fill, shift: -5 }, rest));
};
exports.default = E24;
